import React from 'react';
import styled, { keyframes } from 'styled-components';
import { COLORS } from '../design-system/settings/variables/Colors';

export const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

interface StyleProps {
  size: number;
  color: keyof typeof COLORS;
}

const StyledDiv = styled.div<StyleProps>`
  display: inline-block;
  border: ${({ size }) => size / 10}px solid #f3f3f3;
  border-top: ${({ size }) => size / 10}px solid ${({ color }) => COLORS[color]};
  border-radius: 50%;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  animation: ${spinAnimation} 1s linear infinite;
`;

interface LoadingSpinnerProps {
  color?: StyleProps['color'];
  className?: string;
  size?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  color = 'ctaPrimary',
  className,
  size = 25,
}) => {
  return <StyledDiv className={className} color={color} size={size} />;
};

export default LoadingSpinner;
